import { type Component } from "solid-js";
import { A } from "@solidjs/router";
import { Heart, FileText } from "lucide-solid";
import type { Snip } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";

function formatDate(iso?: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" });
}

/** Feed card summarizing a snip; links to its reader view. */
const SnipCard: Component<{ snip: Snip }> = (props) => {
  return (
    <A href={`/snip/${props.snip.id}`} class="block no-underline">
      <Card class="transition-colors hover:border-primary">
        <CardHeader class="gap-2 p-4 pb-2">
          <div class="flex items-center gap-2 text-xs text-muted-foreground">
            <FileText size={14} />
            <Badge variant="secondary" class="font-normal">
              {props.snip.format ?? "article"}
            </Badge>
            <span>·</span>
            <span>{formatDate(props.snip.updatedAt)}</span>
          </div>
          <CardTitle class="text-base">{props.snip.title}</CardTitle>
        </CardHeader>
        <CardContent class="p-4 pt-0">
          <p class="line-clamp-2 text-sm text-muted-foreground">{props.snip.summary}</p>
          <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground">
            <span>@{props.snip.author?.username}</span>
            <span class={`inline-flex items-center gap-1 ${props.snip.liked ? "text-primary" : ""}`}>
              <Heart size={14} fill={props.snip.liked ? "currentColor" : "none"} />
              {props.snip.likeCount ?? 0}
            </span>
          </div>
        </CardContent>
      </Card>
    </A>
  );
};

export default SnipCard;
